export function getParameterByName(name, search = window.location.search) {
  const urlParams = new URLSearchParams(search);
  return urlParams.get(name) || undefined;
}
